export default (api) => ({
    me: () => api.get('/me'),
    update: (params) => api.put('/me', params),
    resetPassword: () => api.post('/me/reset-password'),
    list: (params) => api.get('/users', { params }),
    getApiToken: () => api.get('/me/apikeys'),
    updateApiToken: (params) => api.post('/me/apikeys', params),
    cancelApiToken: () => api.post('/me/apikeys/cancel'),
})
